module.exports = __webpack_public_path__ + "images/emoji/arrow_left.9754a1cbf4850cfaf26f.png";